import {
  Building2,
  Calendar,
  LogIn,
  LucideIcon,
  ScanLine,
  Search,
  Ship,
  TrendingUp
} from 'lucide-react'

export interface DashboardCard {
  id: string
  title: string
  description: string
  icon: LucideIcon
  iconBgColor: string
  iconColor: string
  borderColor: string
  features: string[]
  route: string
  onClick: string
  disabled?: boolean
}

export interface StatisticItem {
  label: string
  value: string | number
  color: string
  key: string // 用于映射后端数据
}

export const dashboardCards: DashboardCard[] = [
  {
    id: 'search',
    title: '智能搜索',
    description: '支持多类型数据统一查询',
    icon: Search,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: [
      '• 唛头托盘快速查询',
      '• 库位货物精准定位',
      '• 智能识别搜索类型'
    ],
    route: '/search',
    onClick: 'navigateToMarkSearch'
  },
  {
    id: 'inbound',
    title: '入库扫描',
    description: '扫描箱货进行入库操作',
    icon: LogIn,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: [
      '• 主提单扫描入库',
      '• 唛头进度跟踪',
      '• 托盘创建管理'
    ],
    route: '/inbound',
    onClick: 'navigateToInbound'
  },
  {
    id: 'schedule',
    title: '预约任务',
    description: '高效管理预约业务流程',
    icon: Calendar,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: ['• 预约拆柜管理', '• 预约搬出管理', '• 配送任务调度'],
    route: '/schedule',
    onClick: 'navigateToOutbound',
    disabled: false
  },
  {
    id: 'outbound',
    title: '出库扫描',
    description: '快速便捷的出库操作',
    icon: ScanLine,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: ['• 托盘扫码出库', '• 出库状态确认', '• 配送信息更新'],
    route: '/outbound-scan',
    onClick: 'navigateToOutboundScan',
    disabled: false
  },
  {
    id: 'customs',
    title: '保税数据管理',
    description: '管理和查看保税仓储数据',
    icon: Ship,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: ['• 海运货物管理', '• 保税数据统计', '• 报关单据处理'],
    route: '/customs',
    onClick: 'navigateToCustoms'
  },
  {
    id: 'monitor-inbound',
    title: '入库实时进度',
    description: '监控正在入库的进度状态',
    icon: TrendingUp,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: ['• 入库进度监控', '• 托盘状态跟踪', '• 实时数据更新'],
    route: '/monitor-inbound',
    onClick: 'navigateToMonitorInbound'
  },
  {
    id: 'warehouse-area',
    title: '库区管理',
    description: '管理仓库库区和库位信息',
    icon: Building2,
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-500',
    features: ['• 创建和管理库区', '• 自动生成库位编码', '• 库位状态可视化'],
    route: '/warehouse-area',
    onClick: 'navigateToWarehouseArea'
  }
]

export const todayStatistics: StatisticItem[] = [
  {
    label: '今日入库',
    value: '--',
    color: 'text-green-600', // 入库用绿色（增加）
    key: 'todayInbound'
  },
  {
    label: '今日出库',
    value: '--',
    color: 'text-blue-600', // 出库用蓝色（减少）
    key: 'todayOutbound'
  },
  {
    label: '待处理',
    value: '--',
    color: 'text-orange-600', // 待处理用橙色（醒目）
    key: 'pendingCount'
  },
  {
    label: '库存总数',
    value: '--',
    color: 'text-gray-700', // 库存总数用深灰色
    key: 'totalStock'
  }
]